export const FEATURE_TAGS = 'MT filter by tags';
export const FEATURE_LOCAL_LINK = 'MT Local link';